var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Message',{attrs:{"title":_vm.messageTitle,"description":_vm.messageDescription}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }